import { gql } from "@apollo/client";

export const UpdateInstalledBaseNodeAttribute = gql`
    mutation UpdateInstalledBaseNodeAttribute ($id: ID!, $input: PropertyDefinitionUpdateAttributesInput!){
        updateInstalledBaseNodePropertyDefinition (id: $id, input: $input) {
            id
            preferredName
        }
    }
`;
